require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-m-sp-vw.json") })
        }
      }, "path---photos-professional-m-sp-vw");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-m-sp-vw!./.cache/json/photos-professional-m-sp-vw.json
// module id = 833
// module chunks = 231608221292675